import lrCorrArchiveSelect from './_src/lrCorrArchiveSelect.vue'
lrCorrArchiveSelect.install = function(Vue) {
  Vue.component(lrCorrArchiveSelect.name, lrCorrArchiveSelect)
}
export default lrCorrArchiveSelect
